module.exports = __webpack_public_path__ + "img/device_cover_sol.2490ecf8.png";